import React, { useState, useEffect, useContext } from "react";
import { fetchGetPages, fetchGeneralSetting } from "../Api";
import { Contextone } from "../Context.jsx";
import styled from "styled-components";
import yt from "../../images/yt-new.png";
import twitter from "../../images/twitter.png";
import fb from "../../images/fb-logonew.png";
import insta from "../../images/insta-logo.png";
import appStoreIconImage from "../../images/appStoreIcon.png";
import playStoreIconImage from "../../images/googlePlayIcon.png";
import linkedinImage from "../../images/LinkedinLogo.png";
import pinterestImage from "../../images/pinterestLogo.png";
import Cookies from 'js-cookie';

import { Link, useHistory } from "react-router-dom";

const Footer = () => {
  const [page, setpage] = useState([]);

  const [isSetting, setSetting] = useState([])
  const history = useHistory();
  const host = window.location.host;
  const [isPlayStoreLink, setPlayStoreLink] = useState("");
  const [isAppStoreLink, setAppStoreLink] = useState("");
  const [isFacebookLink, setFacebookLink] = useState("");
  const [isInstaLink, setInstaLink] = useState("");
  const [isTwitterLink, setTwitterLink] = useState("");
  const [isYtLink, setYtLink] = useState("");
  const [isLinkedinLink, setLinkedLink] = useState("");
  const [isPinterestLink, setPinterestLink] = useState("");
  const [customLogo, setCustomLogo] = useState("");
  const counterContext = useContext(Contextone);
  const isurl = counterContext.isDomain;
  const apiUrl = `https://${isurl}`;
  const logo = counterContext.isLogo
  counterContext.setPlayStoreId(isPlayStoreLink);
  counterContext.setAppStoreId(isAppStoreLink);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const data = await fetchGetPages(apiUrl);
        setpage(data.result);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchPages();
  }, []);

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const data = await fetchGeneralSetting(apiUrl);
        setSetting(data.result);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchSetting();
  }, []);

  useEffect(() => {
    if (Array.isArray(isSetting)) {
      isSetting.forEach((mtype, index) => {
        if (mtype.key === 'playstore_link' && mtype.value !== '') {
          setPlayStoreLink(mtype.value)
        }
        if (mtype.key === 'appstore_link' && mtype.value !== '') {
          setAppStoreLink(mtype.value)
        }
        if (mtype.key === 'facebook_link' && mtype.value !== '') {
          setFacebookLink(mtype.value)
        }
        if (mtype.key === 'instagram_link' && mtype.value !== '') {
          setInstaLink(mtype.value)
        }
        if (mtype.key === 'youtube_link' && mtype.value !== '') {
          setYtLink(mtype.value)
        }
        if (mtype.key === 'twitter_link' && mtype.value !== '') {
          setTwitterLink(mtype.value)
        }
        if (mtype.key === 'pinterest_link' && mtype.value !== '') {
          setPinterestLink(mtype.value)
        }
        if (mtype.key === 'linkedin_link' && mtype.value !== '') {
          setLinkedLink(mtype.value)
        }
        if (mtype.key === 'custom_logo_css' && mtype.value !== '') {
          setCustomLogo(mtype.value)
        }
      });
    }
  }, [isSetting]);

  let val = customLogo.split(";")
  val = val.map(item => item.trim()).filter(Boolean);

  let cssProperties = {};
  val.forEach(item => {
    let [property, value] = item.split(":").map(str => str.trim());
    cssProperties[property] = value;
  });

  const logoElement = document.querySelector('.logoLink img');

  if (customLogo && window.innerWidth <= 768) {
    for (let property in cssProperties) {
      logoElement.style[property] = cssProperties[property];
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNavLinkClick = (path) => {
    if (history.location.pathname === path) {
      window.location.reload();
    }
  };

  return (
    <MainContainer>
      <FooterContainer>
        <LeftSection>
          <Link to={"/"} onClick={scrollToTop} className='logoLink'>
            <Logo src={logo} alt="Logo" />
          </Link>
        </LeftSection>
        <CenterSection>
          {page.map((mtype, index) => (
            <div key={index} className="page-div">
              <StyledAnchor>
                {/* <Link to={`/${mtype.page_name.replace(/\s+/g, '')}`}> */}
                <Link to={`/Support/${mtype.page_name.replace(/\s+/g, '')}`}
                  onClick={() => Cookies.set('loc', history.location.pathname)}>
                  {/* to={{
                  pathname: `/${mtype.page_name.replace(/\s+/g, '')}`
                }}
              > */}
                  <span>{mtype.page_name}</span>
                </Link>
              </StyledAnchor>
            </div>
          ))}
        </CenterSection>
        <div className="righticon">
          <RightSection>
            {isInstaLink &&
              <SocialMediaIconLink
                href={isInstaLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={insta} alt="Instagram" />
              </SocialMediaIconLink>}
            {isFacebookLink &&
              <SocialMediaIconLink
                href={isFacebookLink}

                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={fb} alt="Facebook" />
              </SocialMediaIconLink>}
            {isYtLink &&
              <SocialMediaIconLink
                href={isYtLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={yt} alt="Youtube" />
              </SocialMediaIconLink>}
            {isTwitterLink &&
              <SocialMediaIconLink
                href={isTwitterLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={twitter} alt="Twitter" />
              </SocialMediaIconLink>}
            {isPinterestLink &&
              <SocialMediaIconLink
                href={isPinterestLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={pinterestImage} alt="Twitter" />
              </SocialMediaIconLink>}
            {isLinkedinLink &&
              <SocialMediaIconLink
                href={isLinkedinLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialMediaIcon src={linkedinImage} alt="Twitter" />
              </SocialMediaIconLink>}
          </RightSection>
          {(isPlayStoreLink || isAppStoreLink) &&
            <div className="icon">
              <div className="available">Available on:</div>
              {isAppStoreLink &&
                <SocialMediaIconLink href={isAppStoreLink} target="_blank">
                  <SocialMediaIcon src={appStoreIconImage}></SocialMediaIcon>
                </SocialMediaIconLink>}
              {isPlayStoreLink &&
                <SocialMediaIconLink href={isPlayStoreLink} target="_blank">
                  <SocialMediaIcon src={playStoreIconImage}></SocialMediaIcon>
                </SocialMediaIconLink>}
            </div>}
        </div>
      </FooterContainer>
      {counterContext.isDomain === 'admin.aaryaadigital.com' && <CopyRightContainer>
        <h6 style={{ fontSize: '15px' }}>
          Aaryaa Digital©️ 2024, All Rights Reserved,
          <p style={{ fontSize: '12px', color: 'gray' }}>
            Aaryaa Digital Pvt, all related channels,
            programming logos, and associated visuals and
            elements are service marks and property of Aaryaa Digital Pvt
          </p>
        </h6>
      </CopyRightContainer>}
    </MainContainer>
  );
};
const MainContainer = styled.footer`
  height : 180px;
  display: flex;
  flex-direction : column;
`;
const FooterContainer = styled.footer`
  background-color: #1e272c;
  color: gray;
  display: flex;
  // padding-bottom: 80px;
  justify-content: space-between;
  align-items: center;
  font-family: "Poppins", sans-serif;

  @media((min-width:853px)and (max-width:1280px)){
          height: 312px; // 9 sepFooterHeight
    }
          

  @media (max-width: 768px){
      height:362px;
      width: 100vw;
   }
`;

const CopyRightContainer = styled.footer`
  background-color: #1e272c;
  color: gray;
  // padding: 20px;
  // margin-top: 5px;
  // margin-bottom: 10px;
  display: flex;
  // padding-bottom: 80px;
  justify-content: space-between;
  align-items: center;
  font-family: "Poppins", sans-serif;

  
  
  
`;

const LeftSection = styled.div`
  position: relative;
  bottom : 10px;
  display: flex;
  // align-items: center;
  flex-direction: column;
`;

const Logo = styled.img`
  // max-width: 30%;
  // max-height: auto;
  // width: 9vw;
  height: 20vh;
  margin-right: 20px;
  @media (min-width : 333px)and (max-width: 400px){
    height:18vh;
  }

  @media (max-width: 768px){

        // active
        margin-top: -125px;
        margin-left: 1vw;

   }

   @media (min-width: 768px) and (max-width: 1024px){
        // width: 11vw;
        height: 12vw;
        margin-left: 1vw;
        margin-top: -8vh;
    }
`;

const CenterSection = styled.div`
  font-weight: 500;
  display: flex; /* Changed from column to row */
  align-items: center;

  .page-div {
    margin-right: 15px; 
    padding: 20px;
    margin-top: 40px;
  }

   @media (max-width: 768px){
    display:block !important;
    // margin-top: 19vh !important;
    // margin-left: 45vw !important;
   margin-top: 1vh !important;
   margin-left: 4vw !important;
    position: relative;
    z-index: 1;
    margin-bottom:6vh;

    .page-div{
      // margin-top: -8vw !important;
      // padding: 2vh !important;
      // margin-right:10vw
      margin-right: 10vw;
        margin-top: -7vw !important;
        padding: 5vh !important;
        margin-bottom: -8vh;
    }
      
  }
    @media (max-width: 595px) {
   .page-div {
        // margin-right: 10vw;
        // margin-bottom: 7vh;
        // margin-top: -7vw !important;
        // padding: 5vh !important;
        margin-right: 10vw;
        margin-bottom: 4vh;
        margin-top: -7vw !important;
        padding: 2vh !important;
    }
}
    @media(max-width:540px){
    .page-div{
      // margin-right: 10vw;
      // margin-top: -3vw !important;
      // padding: 2vh !important;
        margin-right: 11vw;
        margin-top: 3vw !important;
        padding: 2vh !important;
        margin-bottom: -5vh;
      }
    }

  @media (min-width: 768px) and (max-width: 1024px){
    display:block !important;
    margin-top: 2vh !important;

    .page-div{
      // margin-top: 3px !important;
      // padding: 0vh !important;
      margin-bottom: 1vh !important;
        margin-top: 1vh !important;
        padding: 0vh !important;
    }
  }
`;

const StyledAnchor = styled.div`
  text-decoration: none;

  span {
    color: gray;
    transition: color 0.3s ease;
  }

  &:hover span {
    color: white; 
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;

   @media (max-width: 768px){
    // margin-left: -98vw !important;  
    // margin-top: 10vh !important;
    margin-left: -99vw !important;
    // margin-top: 25vh !important;
    margin-top:19vh !important;
    margin-bottom: -6vh;
  }
   @media (max-width: 320px){
    // margin-left: -98vw !important;  
    // margin-top: 10vh !important;
    margin-left: -110vw !important;
    margin-top: 25vh !important;
    margin-bottom: -6vh;
  }

  @media (min-width: 768px) and (max-width: 1024px){
    margin-right: 3vw !important;  
  }
   
`;

const SocialMediaIconLink = styled.a`
  display: inline-block;
  margin: 0px;
`;

const SocialMediaIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-left: 10px;
  // margin-top: 40px;
  margin-top:14px;
  
  @media (max-width: 768px){
    width: 21px;
  height: 21px;
  margin-left: 10px;
  // margin-top: 40px;
  margin-top:14px;
  }
`;

export default Footer;